import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { VehiclePriceRequest } from "./types";

const GET_VEHICLE_PRICE = ApiRequestAdapter.create("/vehicles/price", HttpMethod.GET);

export const vehiclePriceApi = {
  getVehiclePrice: (request: VehiclePriceRequest): AxiosPromise<number> => {
    return apiService.get(GET_VEHICLE_PRICE.url, { params: request });
  },
};
